import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import { useSelector } from "react-redux";
import toastr from "toastr";
import close from "../../assets/images/close.svg";
import { autiFillApi, dumpHighPrice } from "../../Services/mainPageService";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import { convertDobToAge } from "../../utils/utils";
import "./BookDirectPopup.css";
import { useTranslation } from "react-i18next";
import storageService from "../../Services/storageService";
// import { getConfig } from "../../whitelabel_config";

const BookDirectPopup = ({ showPopup, setShowPop, isLowest, handleMenuId }) => {
  // const whitelabelConfig = getConfig();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [title, setTitle] = useState("Male");
  const [, setAge] = useState();
  const [phone, setPhone] = useState();
  const [requests, setRequests] = useState();
  const defaultDialCode = storageService.get("country_code") || "IN";

  const { hotelData, totalPeople, totalAdult, totalChild, dateRange } =
    useSelector((state) => state.hotelInfo);

  const handleSubmit = async () => {
    if (!isValidPhoneNumber(String(phone))) {
      toastr.error("Please enter valid phone number");
      return;
    }

    if (
      name?.length === 0 ||
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      toastr.error("Please enter valid details");
      return;
    }

    const phoneNumber = parsePhoneNumber(String(phone));

    let obj = {
      hotelId: hotelData?.id,
      totalGuests: totalPeople,
      adultCount: totalAdult,
      childrenCount: totalChild,
      name: name?.trim(),
      email: email?.trim(),
      gender: title,
      dialCode: "+" + phoneNumber.countryCallingCode,
      mobile: phoneNumber.nationalNumber,
      checkInDate: dayjs(dateRange?.startDate).format("YYYY/MM/DD"),
      checkOutDate: dayjs(dateRange?.endDate).format("YYYY/MM/DD"),
      reason: requests,
    };

    const response = await dumpHighPrice(obj);
    fireGtmEvent("book_direct_form_filled", { data: obj });
    if (response?.status === 200) {
      toastr.success("Thank you, You'll get a callback soon");
      setShowPop(false);
      setPhone();
      setName("");
      setEmail("");
      setAge();
      setRequests("");
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    const autoFill = async () => {
      const phoneNumber = parsePhoneNumber(String(phone));
      let dialCode = "%2b" + phoneNumber.countryCallingCode;
      const response = await autiFillApi(dialCode, phoneNumber.nationalNumber);
      setName(response?.data?.name);
      setEmail(response?.data?.email);
      setAge(convertDobToAge(response?.data?.dob));
      setTitle(response?.data?.gender);
    };
    isValidPhoneNumber(String(phone)) && autoFill();
  }, [phone]);

  return showPopup ? (
    !isLowest ? (
      <div
        className="bookDirectPopup"
        onClick={(e) => {
          setShowPop(false);
        }}
      >
        <div
          className="bookDirectPopupContainer"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="bookDirectPopupTitle">
            <p style={{ fontSize: "1rem" }}>{t("booking_benefits")}</p>
            <p>
              <img
                src={close}
                alt="close popup"
                onClick={() => {
                  setShowPop(false);
                  fireGtmEvent("bookDirectClosed");
                }}
                style={{ cursor: "pointer" }}
              />
            </p>
          </div>
          <div className="bookDirectImage">
            <img
              src="https://ik.imagekit.io/hotelzifyprod/6d42c495-c5a6-4e9f-9d63-5af60ba1427e.jpg?tr=f-webp"
              alt="staff photo"
              width={250}
              height={250}
              loading="eager"
              style={{ objectFit: "contain", margin: "0 auto" }}
            />
          </div>
          <div className="bookDirectContent">
            <p>{t("best_price_guarantee")}</p>
            <span>{t("book_directly_lowest_rates")}</span>
          </div>
          <div className="bookDirectContent">
            <p>{t("support_local_businesses")}</p>
            <span>{t("booking_support_local")}</span>
          </div>
          <div className="bookDirectContent">
            <p>{t("enhanced_experience")}</p>
            <span>{t("booking_directly_saves")}</span>
          </div>
          <div className="bookDirectContent">
            <p>{t("first_choice_preference")}</p>
            <span>{t("book_direct_choose_room")}</span>
          </div>
          {/* <div className="bookDirectContent">
          <p>Priority Room Upgrades</p>
          <span>Enjoy exclusive priority for available room upgrades.</span>
        </div> */}
        </div>
        <div className="bookDirectFooter" onClick={(e) => e.stopPropagation()}>
          {t("book_directly_hassle_free")}
          <button
            onClick={() => {
              setShowPop(false);
              handleMenuId(2);
            }}
          >
            {t("lets_book")}
          </button>
        </div>
      </div>
    ) : (
      <div className="bookDirectPopup" onClick={(e) => e.stopPropagation()}>
        <div
          className="bookDirectPopupContainer"
          style={{ borderRadius: "8px" }}
        >
          <div className="bookDirectPopupTitle">
            <p>{t("better_price_elsewhere")}</p>
            <p>
              <img
                src={close}
                alt="close popup"
                onClick={() => {
                  setShowPop(false);
                  fireGtmEvent("bookDirectClosed");
                }}
              />
            </p>
          </div>
          <p className="bookDirectSubtext">{t("share_details_best_deal")}</p>
          <div className="checkoutPage__travelerDetails">
            <span className="inputLabel">
              {t("contact_number")} <sup style={{ color: "red" }}>*</sup>{" "}
            </span>
            <div className="checkoutPage__travelerForm">
              <PhoneInput
                defaultCountry={defaultDialCode}
                className="checkout__phone"
                placeholder={t("enter_contact_number")}
                value={phone}
                name="phone"
                onChange={(val) => {
                  setPhone(val);
                }}
              />
            </div>

            <span className="inputLabel">
              {t("full_name")} <sup style={{ color: "red" }}>*</sup>{" "}
            </span>
            <div className="checkoutPage__travelerForm">
              <select
                name="title"
                value={title}
                style={{ border: "none", padding: "0", outline: "none" }}
                onChange={(e) => setTitle(e.target.value)}
              >
                <option value="Male">Mr</option>
                <option value="Female">Ms</option>
                <option value="female">Mrs</option>
              </select>
              <input
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                name="name"
                placeholder={t("enter_name")}
              />
            </div>

            {/* <span className="inputLabel">Enter Age</span>
            <div className="checkoutPage__travelerForm">
              <input
                type="number"
                placeholder="Enter age"
                name="age"
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
            </div> */}

            <span className="inputLabel">
              {t("enter_email_id")} <sup style={{ color: "red" }}>*</sup>{" "}
            </span>

            <div className="checkoutPage__travelerForm">
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value?.trim());
                }}
                name="email"
                placeholder={t("enter_email")}
              />
            </div>

            <span className="inputLabel">{t("help_us_know_more")}</span>

            <div className="checkoutPage__travelerForm">
              <textarea
                value={requests}
                onChange={(e) => {
                  setRequests(e.target.value?.trim());
                }}
                name="requests"
                placeholder={t("where_lower_price")}
              />
            </div>
          </div>

          <div className="bookDirectButton" onClick={handleSubmit}>
            {t("get_best_price")}
          </div>
        </div>
      </div>
    )
  ) : null;
};

export default BookDirectPopup;
